import React, { createRef, FC, useState } from 'react';

// Shared UI Library Components
import { DiscardModal, TabsElement } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './widget-settings.scss';

// Components
import { PopupSettingsTab, TPopupSettingsTabRef } from '../popup-settings-tab/popup-settings-tab';
import { EmbeddedSettingsTab, TEmbeddedSettingsTabRef } from '../embedded-settings-tab/embedded-settings-tab';

// Models
import { IWidgetInfo } from '../../../../../../interfaces/widget-settings.interfaces';

const defaultActiveKey = 'popup-widget';

type TTabKeys = 'popup-widget' | 'embedded-widget';

type TWidgetSettingsProps = {
  widget_settings: IWidgetInfo;
  loading: boolean;
};

export const WidgetSettings: FC<TWidgetSettingsProps> = ({ widget_settings, loading }: TWidgetSettingsProps) => {
  const popupWidgetTabRef = createRef<TPopupSettingsTabRef>();
  const embeddedWidgetTabRef = createRef<TEmbeddedSettingsTabRef>();

  const [discardOpen, setDiscardOpen] = useState<boolean>(false);
  const [activeKey, setActiveKey] = useState<TTabKeys>(defaultActiveKey);
  const [nextKey, setNextKey] = useState<TTabKeys | null>(null);

  const toggleDiscardModal = (): void => {
    setDiscardOpen(!discardOpen);
  }

  // const resetRefState = (): void => {
  //   if (activeKey === 'popup-widget') {
  //     popupWidgetTabRef.current?.resetState();
  //     return;
  //   }
  //   if (activeKey === 'embedded-widget') {
  //     embeddedWidgetTabRef.current?.resetState();
  //     return;
  //   }
  // }

  // const onDiscardChangesHandler = (state: boolean): void => {
  //   if (state) {
  //     toggleDiscardModal();
  //     resetRefState();
  //     setActiveKey(nextKey ?? defaultActiveKey);
  //     setNextKey(null);
  //     return;
  //   }
  //   toggleDiscardModal();
  // }

  const onTabClickHandler = (key: string, event: any) => {
    event.preventDefault();
    setNextKey(key as TTabKeys);

    // if (popupWidgetTabRef.current?.isHasChanges() || embeddedWidgetTabRef.current?.isHasChanges()) {
    //   toggleDiscardModal();
    //   return;
    // }

    setActiveKey(key as TTabKeys);
  }

  return (
    <div className="widget-settings">

      {/*<DiscardModal*/}
      {/*  open={ discardOpen }*/}
      {/*  onCancel={ onDiscardChangesHandler }*/}
      {/*  title={ 'Are you sure you want to discard changes?' }*/}
      {/*/>*/}

      <TabsElement
        activeKey={ activeKey }
        onTabClick={ onTabClickHandler }
        items={ [
          {
            key: 'popup-widget',
            label: 'Popup Widget',
            children: <PopupSettingsTab widget_settings={ widget_settings } loading={ loading }/>,
          },
          {
            key: 'embedded-widget',
            label: 'Embedded Widget',
            children: <EmbeddedSettingsTab widget_settings={ widget_settings } loading={ loading }/>,
          },
        ] }/>
    </div>
  );
}
